import { render, staticRenderFns } from "./healthComponent.vue?vue&type=template&id=e50333c8&scoped=true"
import script from "./healthComponent.vue?vue&type=script&lang=js"
export * from "./healthComponent.vue?vue&type=script&lang=js"
import style0 from "./healthComponent.vue?vue&type=style&index=0&id=e50333c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50333c8",
  null
  
)

export default component.exports